import { t } from '@lingui/macro'
import format from 'date-fns/format'
import { useTheme } from 'styled-components'

import { Flex, FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { ProgressBar } from '@/@bothrs-ui/web/components/progress/ProgressBar'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { mixpanel } from '@/mixpanel'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type IdleTimerWarningModalProps = InheritableModalProps & {
  timeRemaining: number
  warningPercentage: number
  timeout: number
}

export const IdleTimerWarningModal = ({
  timeRemaining,
  warningPercentage,
  timeout,
  ...props
}: IdleTimerWarningModalProps) => {
  const theme = useTheme()
  const progress = timeRemaining / (warningPercentage * timeout)
  const timeRemainingString = format(new Date(timeRemaining), 'm:ss')

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center' gap={theme.UI.Spacing.Space7}>
        <H2 color={theme.Colors.Neutrals.Darkest} noMargin>
          {t({ id: 'auto.logout.title', message: 'Je sessie loopt af' })}
        </H2>

        <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'auto.logout.body1',
            message: 'We merken dat je al even inactief bent, je sessie wordt bijna beëindigd.',
          })}

          <br />
          {t({
            id: 'auto.logout.body2',
            message: 'Verleng hieronder je sessie.',
          })}
        </Span>

        <Flex alignItems='center' gap={theme.UI.Spacing.Space4}>
          <ProgressBar
            min={0}
            max={1}
            value={progress}
            thickness={8}
            color={theme.Colors.Theme.Primary}
            backgroundColor={theme.Colors.Neutrals.Lighter}
            radius={theme.UI.BorderRadius.Small}
          />
          <H2 noMargin color={theme.Colors.Theme.Primary}>
            {timeRemainingString}
          </H2>
        </Flex>

        <FlexColumn gap={theme.UI.Spacing.Space2}>
          <Button
            variant='Primary'
            onClick={() => {
              props.onClose?.()
              mixpanel.track('extend_session')
            }}
          >
            {t({
              id: 'auto.logout.cancel',
              message: 'Sessie verlengen',
            })}
          </Button>
        </FlexColumn>
      </FlexColumn>
    </Modal>
  )
}
